/**
 * What a failed sign-in can be asked, without asserting what it is.
 *
 * THE DEFECT THESE REPLACE. Both catch blocks read `e.code` twice:
 *
 *     if (!e.code) { alert(e?.error?.message || e.message); }
 *     if (e.code.startsWith('auth/')) { alert('user_pwd_not_found'); }
 *
 * When the failure is not a Firebase error it has no code, so the first branch
 * shows the message and the second calls undefined.startsWith and throws. The
 * alert appeared and the handler died straight after it, which is why the
 * return undefined below it was never reached on that path.
 *
 * `e: any` is what let both lines through. Nothing here changes what the user
 * is shown; it stops the second read from happening when there is no code.
 */
export function theFirebaseErrorCode(error: unknown): string | undefined {
  if (error === null || typeof error !== 'object') {
    return undefined;
  }
  const code = (error as { code?: unknown }).code;
  return typeof code === 'string' ? code : undefined;
}

/** The message worth showing, in the order the screens already tried. */
export function whatTheFailureSays(error: unknown): string {
  if (error === null || typeof error !== 'object') {
    return String(error ?? '');
  }
  const asObject = error as { error?: { message?: unknown }; message?: unknown };
  const nested = asObject.error?.message;
  if (typeof nested === 'string' && nested) {
    return nested;
  }
  return typeof asObject.message === 'string' ? asObject.message : '';
}
